import React from "react";
import { Link } from "react-router-dom";
import { defaultPfpUrl } from "../../utils";

/**
 * Map pin marker. Profile pins link to user/org pages; location pins are static.
 * @param {{ item: object }} props
 * @returns {JSX.Element | null}
 */
const Marker = ({ item }) => {
    if (!item) return null;

    if (item.type === "location") {
        return (
            <div
                className="relative block"
                style={{ transformOrigin: "bottom center", width: "40px", height: "50px" }}
                title={item.name || "Location"}
                aria-label={item.name || "Location"}
            >
                <svg
                    width="40"
                    height="50"
                    viewBox="0 0 40 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute bottom-0 left-0 drop-shadow-lg"
                >
                    <path
                        d="M20 0C8.954 0 0 8.954 0 20C0 30 20 50 20 50C20 50 40 30 40 20C40 8.954 31.046 0 20 0Z"
                        fill="var(--color-accent)"
                    />
                    <circle cx="20" cy="18" r="7" fill="var(--ui-card)" />
                </svg>
            </div>
        );
    }

    const isUser = item.type === 'user';
    const name = isUser 
        ? (item.first_name && item.last_name ? `${item.first_name} ${item.last_name}` : item.username || "User")
        : (item.name || "Organization");

    // Determine the profile URL
    const profileUrl = isUser ? `/profile/${item.id}` : `/organization/${item.id}`;

    return (
        <Link
            to={profileUrl}
            className="cursor-pointer transform transition-transform hover:scale-110 relative block"
            style={{ transformOrigin: "bottom center", width: "40px", height: "50px" }}
            onClick={(e) => {
                // Stop event propagation to prevent map interactions
                e.stopPropagation();
            }}
        >
            {/* Profile picture circle at top */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 z-10">
                <div className="w-12 h-12 rounded-full border-2 border-accent bg-ui-card p-0.5 shadow-md">
                    <img
                        src={item.pfp_url || defaultPfpUrl}
                        alt={name}
                        className="w-full h-full rounded-full object-cover"
                        onError={(e) => {
                            e.target.src = defaultPfpUrl;
                        }}
                    />
                </div>
            </div>
            
            {/* Map pin SVG */}
            <svg
                width="40"
                height="50"
                viewBox="0 0 40 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute bottom-0 left-0"
            >
                {/* Pin body (accent colored) */}
                <path
                    d="M20 0C8.954 0 0 8.954 0 20C0 30 20 50 20 50C20 50 40 30 40 20C40 8.954 31.046 0 20 0Z"
                    fill="var(--color-accent)"
                    className="drop-shadow-lg"
                />
            </svg>
        </Link>
    );
};

export default Marker;
